/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editbusinessprofile2Inputs */

const en_editbusinessprofile2 = /** @type {(inputs: Editbusinessprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Business Profile`)
};

const de_editbusinessprofile2 = /** @type {(inputs: Editbusinessprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensprofil bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit Business Profile" |
*
* @param {Editbusinessprofile2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editbusinessprofile2 = /** @type {((inputs?: Editbusinessprofile2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editbusinessprofile2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editbusinessprofile2(inputs)
	return de_editbusinessprofile2(inputs)
});
export { editbusinessprofile2 as "editBusinessProfile" }